import { render, staticRenderFns } from "./AssetDetailView.vue?vue&type=template&id=39fa72b0&scoped=true&"
import script from "./AssetDetailView.vue?vue&type=script&lang=js&"
export * from "./AssetDetailView.vue?vue&type=script&lang=js&"
import style0 from "./AssetDetailView.vue?vue&type=style&index=0&id=39fa72b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fa72b0",
  null
  
)

/* custom blocks */
import block0 from "./AssetDetailView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports